import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

function fmtErr(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-deep p-4" data-testid="admin-login">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <div className="flex items-center gap-2 justify-center">
          <img src="/logo.webp" alt="Smog Hut Modesto" className="h-14 w-auto" />
        </div>
        <h1 className="mt-6 font-head font-bold text-xl text-ink text-center">Sign in to the dashboard</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required className="w-full rounded-xl border border-line px-4 py-3 text-sm font-body focus:outline-none focus:ring-2 focus:ring-volt" />
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required className="w-full rounded-xl border border-line px-4 py-3 text-sm font-body focus:outline-none focus:ring-2 focus:ring-volt" />
          <button data-testid="login-submit" disabled={loading} className="btn-volt w-full disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
